import type { GetReadyTaskCatalogEntry, GetReadyTaskKey } from "./types";

export const GET_READY_TASK_CATALOG: Record<
	GetReadyTaskKey,
	GetReadyTaskCatalogEntry
> = {
	complete_profile: {
		taskKey: "complete_profile",
		titleKey: "taskCatalog.complete_profile.title",
		subtextKey: "taskCatalog.complete_profile.subtext",
		iconName: "fill",
	},
	insurance: {
		taskKey: "insurance",
		titleKey: "taskCatalog.insurance.title",
		subtextKey: "taskCatalog.insurance.subtext",
		iconName: "upload",
	},
	schedule_appointment: {
		taskKey: "schedule_appointment",
		titleKey: "taskCatalog.schedule_appointment.title",
		subtextKey: "taskCatalog.schedule_appointment.subtext",
		iconName: "book",
	},
	book_appointment: {
		taskKey: "book_appointment",
		titleKey: "taskCatalog.book_appointment.title",
		subtextKey: "taskCatalog.book_appointment.subtext",
		iconName: "book",
	},
	upload_documents: {
		taskKey: "upload_documents",
		titleKey: "taskCatalog.upload_documents.title",
		subtextKey: "taskCatalog.upload_documents.subtext",
		iconName: "upload",
	},
	sign_consent: {
		taskKey: "sign_consent",
		titleKey: "taskCatalog.sign_consent.title",
		subtextKey: "taskCatalog.sign_consent.subtext",
		iconName: "review-sign",
	},
	fill_health_questionnaire: {
		taskKey: "fill_health_questionnaire",
		titleKey: "taskCatalog.fill_health_questionnaire.title",
		subtextKey: "taskCatalog.fill_health_questionnaire.subtext",
		iconName: "fill",
	},
};

export const UNKNOWN_GET_READY_TASK_FALLBACK: Pick<
	GetReadyTaskCatalogEntry,
	"titleKey" | "subtextKey" | "iconName"
> = {
	titleKey: "taskCatalog.unknown.title",
	subtextKey: "taskCatalog.unknown.subtext",
	iconName: "fill",
};
